import { IWizardStep, TextureLevel } from "./WizardStepDefinitions"
import { useContext } from "react"
import { TextureTestWizardContext, WizardSectionId } from "./TextureTestWizardContextProvider"
import { WizardSection } from "./WizardSection"

export const WizardQuestion = (props: { level: TextureLevel; step: IWizardStep; stepIndex: number }) => {
  const { section, currentStepIndex, answer } = useContext(TextureTestWizardContext)
  const visible = section === WizardSectionId.Questionnaire && currentStepIndex === props.stepIndex

  return (
    <WizardSection visible={visible}>
      <p key="question" dangerouslySetInnerHTML={{ __html: props.step.question }} />
      {props.step.answers.map((a, i) => (
        <button
          id={`btn-iddsi-level-${TextureLevel[props.level]}-question-${currentStepIndex}-answer-${i}`}
          key={`answer-${i}`}
          onClick={() => answer(i)}>
          {a.label}
        </button>
      ))}

      {props.step.image && <img key={`image`} src={props.step.image.src} alt={props.step.image.alt} />}
    </WizardSection>
  )
}
